// Definição para o modal de busca de Operações de Venda
// Factory function - recebe os filtros como parâmetros, sem magic strings
// Filtra por Saída (TP_MOVIMENTO.Saida) e Ativas

import { ST } from '@/constants/ST'
import { TP_MOVIMENTO } from '@/constants/TP_MOVIMENTO'

const formatarBoolean = (valor) => valor ? 'Sim' : 'Não'

export const criarConfigBuscaOperacaoVenda = (lstStatus = ST.Ativo, lstTipoMovimento = TP_MOVIMENTO.Saida) => ({
  label: 'Operação',
  placeholder: 'ID ou Descrição...',
  titulo: 'Selecionar Operação',
  tamanho: 'xl',
  endpointApi: 'Operacoes',
  idField: 'idOperacao',
  displayField: 'idOperacao',
  descField: 'descricao',
  camposFiltro: [
    { label: 'Descrição', model: 'busca', tipo: 'text' }
  ],
  colunasGrid: [
    { header: 'ID', dataField: 'idOperacao', width: '8%' },
    { header: 'Descrição', dataField: 'descricao', width: '30%' },
    { header: 'Mov. Financeiro', dataField: 'movimentaFinanceiro', width: '14%', formatter: formatarBoolean, align: 'center' },
    { header: 'Mov. Estoque', dataField: 'movimentaEstoque', width: '14%', formatter: formatarBoolean, align: 'center' },
    { header: 'CFOP Dentro Estado', dataField: 'cfopDentroEstado', width: '12%' },
    { header: 'CFOP Fora Estado', dataField: 'cfopForaEstado', width: '12%' },
    { header: 'CFOP Exterior', dataField: 'cfopExterior', width: '12%' }
  ],
  filtrosFixos: {
    lstStatus,
    lstTipoMovimento
  }
})
